function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyOnboardNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.4525 9C1.86 8.2875 1.5 7.3725 1.5 6.375C1.5 4.11 3.3525 2.25 5.625 2.25H9.375C11.64 2.25 13.5 4.11 13.5 6.375C13.5 8.64 11.6475 10.5 9.375 10.5H7.5",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5475 9C16.14 9.7125 16.5 10.6275 16.5 11.625C16.5 13.89 14.6475 15.75 12.375 15.75H8.625C6.36 15.75 4.5 13.89 4.5 11.625C4.5 9.36 6.3525 7.5 8.625 7.5H10.5",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyOnboardNav);
export default __webpack_public_path__ + "static/media/easy-onboard-nav.f71df9807487e816b32af8994f2d8e39.svg";
export { ForwardRef as ReactComponent };